import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import PasswordValidation from './PasswordValidation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import { LEAKED_PASSWORD_KB } from '../constants/KnowledgeBaseUrls';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChangePasswordModal = ({
  stagedCurrentPassword,
  stagedCurrentPasswordValidationMessage,
  stagedNewPassword,
  stagedNewPasswordValidationMessage,
  stagedNewPasswordVisible,
  updatePasswordButtonDisabled,
  onCloseModal,
  onForgotPassword,
  onUpdatePassword,
  onStagedCurrentPasswordChanged,
  onStagedNewPasswordChanged,
  toggleNewPasswordVisible,
  leakedPassword
}) => {
  const passwordVisibilityToggleKey = stagedNewPasswordVisible ? 'userPreferences.labels.hidePassword' : 'userPreferences.labels.showPassword';
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCloseModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.updatePassword"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [leakedPassword && /*#__PURE__*/_jsxs(UIAlert, {
        use: "inline",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.errors.leakedPassword.title"
        }),
        type: "danger",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "userPreferences.errors.leakedPassword.body"
        }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: LEAKED_PASSWORD_KB
        })]
      }), /*#__PURE__*/_jsxs(UIForm, {
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.labels.confirmCurrentPassword"
          }),
          validationMessage: stagedCurrentPasswordValidationMessage,
          error: stagedCurrentPasswordValidationMessage !== undefined,
          help: /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            onClick: onForgotPassword,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.labels.forgotPassword"
            })
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: stagedCurrentPassword,
            type: "password",
            "data-test-id": "staged-current-password",
            onChange: evt => onStagedCurrentPasswordChanged(evt.target.value)
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.labels.newPassword"
          }),
          validationMessage: stagedNewPasswordValidationMessage,
          error: stagedNewPasswordValidationMessage !== undefined,
          help: /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            onClick: toggleNewPasswordVisible,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: passwordVisibilityToggleKey
            })
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: stagedNewPassword,
            "data-test-id": "staged-new-password",
            onChange: evt => onStagedNewPasswordChanged(evt.target.value),
            type: stagedNewPasswordVisible ? 'text' : 'password'
          })
        }), /*#__PURE__*/_jsx(PasswordValidation, {
          password: stagedNewPassword
        })]
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: onUpdatePassword,
        disabled: updatePasswordButtonDisabled,
        "data-test-id": "reset-password-modal-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.updatePassword"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: onCloseModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.cancel"
        })
      })]
    })]
  });
};
ChangePasswordModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onForgotPassword: PropTypes.func.isRequired,
  stagedCurrentPassword: PropTypes.string.isRequired,
  stagedCurrentPasswordValidationMessage: PropTypes.string,
  stagedNewPassword: PropTypes.string.isRequired,
  stagedNewPasswordValidationMessage: PropTypes.node,
  stagedNewPasswordVisible: PropTypes.bool.isRequired,
  onStagedCurrentPasswordChanged: PropTypes.func.isRequired,
  onStagedNewPasswordChanged: PropTypes.func.isRequired,
  onUpdatePassword: PropTypes.func.isRequired,
  toggleNewPasswordVisible: PropTypes.func.isRequired,
  updatePasswordButtonDisabled: PropTypes.bool.isRequired,
  leakedPassword: PropTypes.bool
};
export default ChangePasswordModal;